import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24LinkG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      }), /*#__PURE__*/jsxs("g", {
        fill: props.iconColor ? props.iconColor : "#010505",
        children: [/*#__PURE__*/jsx("path", {
          d: "M14.208 9.2a.75.75 0 0 1 1.128.983l-.068.076-5.131 5.132a.75.75 0 0 1-1.127-.985l.066-.076 5.132-5.131z"
        }), /*#__PURE__*/jsx("path", {
          d: "M8.177 10.197a.75.75 0 0 1 1.128.983l-.067.077-2.407 2.407c-1.316 1.316-1.45 3.264-.37 4.344 1.04 1.04 2.888.952 4.199-.236l.143-.136 2.406-2.407a.75.75 0 0 1 1.128.984l-.067.077-2.406 2.406C9.99 20.57 7.1 20.767 5.4 19.067c-1.65-1.65-1.512-4.427.214-6.3l.157-.164zM12.481 5.894c1.873-1.873 4.765-2.072 6.464-.373 1.653 1.653 1.512 4.428-.214 6.303l-.157.162-2.406 2.406a.75.75 0 0 1-1.128-.983l.067-.077 2.406-2.406c1.317-1.318 1.451-3.264.371-4.344-1.04-1.04-2.888-.953-4.2.235l-.142.137-2.406 2.407a.75.75 0 0 1-1.129-.985l.068-.076z"
        })]
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24LinkG$1 = Svg24LinkG;

export { Svg24LinkG$1 as default };
